"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcceptedBanner = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var styles = __importStar(require("./AcceptedBanner.css"));
var react_1 = __importDefault(require("react"));
var AcceptedBanner = function (_a) {
    var acceptedAt = _a.acceptedAt;
    var date = new Date(acceptedAt);
    var formattedDate = date.toLocaleDateString(undefined, {
        day: "numeric",
        month: "long",
        year: "numeric",
    });
    var formattedTime = date
        .toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
    })
        .toLowerCase();
    return (react_1.default.createElement(kaleidoscope_1.Stack, { gap: "xs", direction: "horizontal", justify: "spaceBetween", align: "center", className: styles.acceptedBanner },
        react_1.default.createElement(kaleidoscope_1.Stack, null,
            react_1.default.createElement(icons_1.Security, { size: icons_1.IconSize.Small, className: styles.lockIcon })),
        react_1.default.createElement(kaleidoscope_1.Stack, { direction: "horizontal", gap: "xs" },
            react_1.default.createElement(icons_1.Tick, { className: styles.tickStyle }),
            react_1.default.createElement(kaleidoscope_1.Text, { className: styles.acceptBannerText, size: "s" }, "Accepted and locked")),
        react_1.default.createElement(kaleidoscope_1.Stack, null,
            react_1.default.createElement(kaleidoscope_1.Layer, { offset: 3 }, function () { return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, button: function (buttonProps) { return (react_1.default.createElement(kaleidoscope_1.IconButton, __assign({}, buttonProps, { isIconOnly: true, isRound: true, size: kaleidoscope_1.ButtonSize.Small, type: kaleidoscope_1.ButtonType.Tertiary, icon: react_1.default.createElement(icons_1.InformationCircle, { size: icons_1.IconSize.Small }) }))); } },
                react_1.default.createElement(kaleidoscope_1.Stack, { direction: "vertical", gap: "s" },
                    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.popoverHeading, size: "m" }, "Accepted and locked."),
                    react_1.default.createElement(kaleidoscope_1.Text, { className: styles.popoverText, size: "s" },
                        "This Qwilr page was accepted on ",
                        formattedDate,
                        " at ",
                        formattedTime,
                        ". It is now locked in perpetuity.")))); }))));
};
exports.AcceptedBanner = AcceptedBanner;
